export const dateSortValue = (date?: string) => new Date(date ?? '').getTime() || 0
